module.exports = __webpack_public_path__ + "static/media/2.9f441d0d.jpg";